import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { SuitProgressDto, AdrDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-suitprogress',
  templateUrl: './suitprogress.component.html',
  styleUrls: ['./suitprogress.component.scss']
})
export class SuitprogressComponent implements OnInit {
  
  suitprogressForm: FormGroup;
  @Input() selectedSuitProgresss: AdrDto;
  @Input() adrProgresss: SuitProgressDto[];
  @Input() adrs: any[];
  @Output() emitSave = new EventEmitter<SuitProgressDto>();
  @Output() deleteEvent = new EventEmitter<any>();
  
  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.suitprogressForm = this.fb.group({
      AdrId: [''],
      SuitNo: [''],
      ProgressDate: [''],
      ProgressRemarks: [''],
      SuitStatus	: [''],
      InputStaff: [''],
      SubscriberId: ['0'],
      SubscriptionUserId: ['0'],
      id: ['']
    });   
    // if(this.selectedSuitProgresss?.suitProgress != null && this.selectedSuitProgresss?.suitProgress.length) {
    //   this.setAdrProgresss(this.selectedSuitProgresss?.suitProgress);
    //   this.onCreate();
    // }          
  }

  setAdrProgresss(adrProgresss: SuitProgressDto[]) {
    adrProgresss.forEach(value => {
      this.suitprogressForm.patchValue({
        AdrId: value.AdrId,
        SuitNo: value.SuitNo,
        ProgressDate: value.ProgressDate,
        ProgressRemarks: value.ProgressRemarks,
        SuitStatus: value.SuitStatus,
        InputStaff: value.InputStaff,
        id: value.id
      });
      
     });
   }

   public errorHandling = (control: string, error: string) => {
    return this.suitprogressForm.controls[control].hasError(error);
  };

  onCreate() {
    this.suitprogressForm.reset();
    
  }

  getAdr(id) {
    return this.adrs.find(adr => adr.id === id);
  }

  onDelete(value, i) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        this.deleteEvent.emit(value.id);

        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }


  onSubmit(formValue: SuitProgressDto) {
    formValue.AdrId = this.selectedSuitProgresss.id;
    formValue.SubscriberId = this.selectedSuitProgresss.SubscriberId;
    formValue.SubscriptionUserId = this.selectedSuitProgresss.SubscriptionUserId;
    if(this.suitprogressForm.valid){
      this.emitSave.emit(formValue);
    }
  }
}
